import { render, staticRenderFns } from "./StatisticModal.vue?vue&type=template&id=0f680160&scoped=true&"
import script from "./StatisticModal.vue?vue&type=script&lang=js&"
export * from "./StatisticModal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticModal.vue?vue&type=style&index=0&id=0f680160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f680160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
